var _path, _rect, _path2, _path3, _circle, _mask, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifyMe = function SvgNotifyMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 28.5,
    x: 3.25,
    y: 18.259,
    stroke: "#000",
    strokeWidth: 2.5,
    rx: 2.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.5,
    d: "M5 19.009 19.8 32.54a4 4 0 0 0 5.4 0L40 19.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M54.778 38.812c-.036-.685.469-1.264 1.129-1.293l5.83-.256c.66-.029 1.225.503 1.261 1.188.037.684-.469 1.263-1.129 1.292l-5.83.256c-.66.029-1.224-.503-1.26-1.187M52.465 34.025c.383.564 1.13.704 1.669.314l3.826-2.771c.539-.39.665-1.163.281-1.727-.383-.563-1.13-.704-1.669-.314L52.746 32.3c-.539.39-.665 1.163-.282 1.726M46.795 30.97a1.17 1.17 0 0 0 1.53-.732l1.577-4.565c.222-.642-.103-1.356-.726-1.595a1.17 1.17 0 0 0-1.529.731l-1.577 4.565c-.222.643.103 1.357.725 1.595",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.691,
    cy: 46.691,
    r: 12.691,
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "notifyMe_svg__a",
    width: 29,
    height: 29,
    x: 25.5,
    y: 31.5,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5 31.5h29v29h-29z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 57.423c6.309 0 11.423-5.114 11.423-11.423S46.31 34.577 40 34.577 28.577 39.69 28.577 46 33.69 57.423 40 57.423M53.5 46c0 7.456-6.044 13.5-13.5 13.5S26.5 53.456 26.5 46 32.544 32.5 40 32.5 53.5 38.544 53.5 46",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 53.27a1.04 1.04 0 0 1-1.038-1.04v-7.268a1.038 1.038 0 0 1 2.076 0v7.269c0 .573-.464 1.038-1.038 1.038",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 38.73a1.558 1.558 0 1 0 0 3.116 1.558 1.558 0 0 0 0-3.115"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 57.423c6.309 0 11.423-5.114 11.423-11.423S46.31 34.577 40 34.577 28.577 39.69 28.577 46 33.69 57.423 40 57.423M53.5 46c0 7.456-6.044 13.5-13.5 13.5S26.5 53.456 26.5 46 32.544 32.5 40 32.5 53.5 38.544 53.5 46",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 53.27a1.04 1.04 0 0 1-1.038-1.04v-7.268a1.038 1.038 0 0 1 2.076 0v7.269c0 .573-.464 1.038-1.038 1.038",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40 38.73a1.558 1.558 0 1 0 0 3.116 1.558 1.558 0 0 0 0-3.115"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M51.223 46c0 6.198-5.025 11.223-11.223 11.223v.4c6.42 0 11.623-5.204 11.623-11.623zM40 34.777c6.198 0 11.223 5.025 11.223 11.223h.4c0-6.42-5.204-11.623-11.623-11.623zM28.777 46c0-6.198 5.025-11.223 11.223-11.223v-.4c-6.42 0-11.623 5.204-11.623 11.623zM40 57.223c-6.198 0-11.223-5.025-11.223-11.223h-.4c0 6.42 5.204 11.623 11.623 11.623zm0 2.477c7.566 0 13.7-6.134 13.7-13.7h-.4c0 7.345-5.955 13.3-13.3 13.3zM26.3 46c0 7.566 6.134 13.7 13.7 13.7v-.4c-7.345 0-13.3-5.955-13.3-13.3zM40 32.3c-7.566 0-13.7 6.134-13.7 13.7h.4c0-7.345 5.955-13.3 13.3-13.3zM53.7 46c0-7.566-6.134-13.7-13.7-13.7v.4c7.345 0 13.3 5.955 13.3 13.3zm-14.939 6.23c0 .685.555 1.24 1.239 1.24v-.4a.84.84 0 0 1-.839-.84zm0-7.268v7.269h.4v-7.27zM40 43.723c-.684 0-1.239.555-1.239 1.239h.4c0-.464.376-.839.839-.839zm1.239 1.239c0-.684-.555-1.239-1.239-1.239v.4c.463 0 .839.376.839.839zm0 7.269v-7.27h-.4v7.27zM40 53.469c.684 0 1.239-.554 1.239-1.238h-.4a.84.84 0 0 1-.839.838zm-1.358-13.18c0-.75.608-1.358 1.358-1.358v-.4c-.97 0-1.758.787-1.758 1.758zM40 38.93c.75 0 1.358.608 1.358 1.358h.4c0-.971-.787-1.758-1.758-1.758zm1.358 1.358c0 .75-.608 1.357-1.358 1.357v.4c.97 0 1.758-.787 1.758-1.758zM40 41.646c-.75 0-1.358-.608-1.358-1.358h-.4c0 .971.787 1.758 1.758 1.758z",
    mask: "url(#notifyMe_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 46.009,
    r: 10,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 46.509,
    r: 12.5,
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M45.401 42.98c.4.395.41 1.048.024 1.458l-5.562 5.89-3.91-3.8a1.05 1.05 0 0 1-.038-1.457.99.99 0 0 1 1.424-.039l2.463 2.394 4.176-4.422a.99.99 0 0 1 1.423-.025",
    clipRule: "evenodd"
  })));
};
export default SvgNotifyMe;